<template>
  <div>
    <div class="app-content content" >
      <div class="content-overlay"></div>
      <div class="header-navbar-shadow"></div>
      <div class="content-wrapper">
        <div class="content-header row">
          <div class="content-header-left col-md-9 col-12 mb-2">
            <Breadcrumb
                name="Switch"
                bc1="App"
                bc2="switch"
                bc3="List"
                path="switch"
            ></Breadcrumb>
          </div>
          <div class="col-3">
            <div class="d-flex align-items-center justify-content-end">
              <button
                  type="button"
                  class="btn btn-gradient-danger btn-sm"
                  @click="$router.back()"
              >
                <span class="text-nowrap">Back</span>
              </button>
            </div>
          </div>
          <div
              class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
          >

          </div>
        </div>
        <div class="content-body">
          <div class="col-12 d-flex mt-2  justify-content-center" v-if="loader">
            <div class="spinner-border text-primary"></div>
          </div>
          <div class="card" v-else>
            <div class="m-2">
              <div class="row">
                <div class="col-10">
                  <p class="mt-1">
        <span class="text-dark font-weight-bolder font-small-3">
          Channel Name:
          <span class="text-primary badge badge-light-primary font-small-2">
            {{this.channelSwitchPFAC?.row?.name}}
          </span>
        </span>
                    <span class="text-dark font-weight-bolder font-small-3 ml-sm-1">
          Code:
          <span class="text-primary badge badge-light-primary font-small-2">
         {{this.channelSwitchPFAC?.row?.code}}
          </span>
        </span>
                  </p>
                </div>
              </div>
            </div>
            <div class="m-2">
              <div class="row">
                <div class="col-md-12 col-12">
                  <div class="d-flex align-items-center justify-content-end"  v-if="!isEmpty(switchList)">
                    <button
                        type="button"
                        class="btn btn-primary"
                        @click="onboardPfac"
                    >
                      <span class="text-nowrap">Onboard With Switch</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <section class="app-user-list">
              <section>
                <div class="row">
                  <div class="col-sm-12">
                    <div class="card">
                      <div class="card-header">
                        <h4 class="card-title">Switches</h4>
                      </div>
                      <div>
                        <div class="row mt-2">
                          <div class="col-12">
                            <div class="card">
                              <div class="table-responsive">
                                <table class="table">
                                  <thead>
                                  <tr>
                                    <th>Switch ID</th>
                                    <th>Switch Ref</th>
                                    <th>Name</th>
                                    <th>Status</th>
                                    <th>Created At</th>
                                    <th>Updated At</th>
                                    <th>Actions</th>

                                  </tr>
                                  </thead>
                                  <tbody>
                                  <tr v-if="isEmpty(switchList)">
                                    <td
                                        colspan="8"
                                        class="font-weight-bolder font-medium-2"
                                        style="text-align: center"
                                    >
                                      No Switch Onboarded Yet!
                                    </td>
                                  </tr>
                                  <tr v-if="isEmpty(switchList)">
                                    <td
                                        colspan="8"
                                        class="font-weight-bolder font-medium-2 border-0"
                                        style="text-align: center"
                                    >
                                     <button class="btn btn-sm btn-primary" @click="onboardPfac">Onboard Now</button>
                                    </td>
                                  </tr>
                                  <tr v-for="(item,index) in switchList" :key="index">
                                    <td><span>{{ item.payment_switch_id }}</span></td>
                                    <td><span
                                        class=" font-weight-bolder text-dark">{{ item.status == 0? '-' : item.switch_ref_id}}</span>
                                    </td>
                                    <td><span class="badge badge-light-success">{{ item.payment_switch?.name}}</span></td>
                                    <td><div class="row">
                                      <div class="col-12">
                                        <span class="badge badge-light-dark">{{ item.status == 0 ? 'Pending for Switch Activation' : 'Active'}}</span>
                                      </div>
                                      <div class="col-12 mt-sm-1 " v-if="item.status == 0">
                                        <h6 class="text-primary">{{ item.status == 0 ? 'APP ID: ' + item.switch_ref_id : ''}}</h6>
                                      </div>
                                    </div></td>
                                    <td><span class="text-dark">{{ customFormatDateTime(item.created_at)}}</span></td>
                                    <td><span class="text-dark">{{ customFormatDateTime(item.updated_at)}}</span></td>
                                    <td class="d-flex">
                                      <button class="btn btn-sm btn-primary badge"
                                              @click="showDetails(item)">
                                        View Details
                                      </button>
                                      <button v-show="item.status != 0" class="btn btn-sm btn-primary badge ml-1"
                                              @click="update(item)">
                                        Update
                                      </button>
                                      <button class="btn btn-sm btn-primary badge ml-1"
                                              @click="resetKeys(item)">
                                        Reset key on switch
                                      </button>
                                    </td>
                                  </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

            </section>
          </div>
        </div>
        <TreeModal :show="showDetailsModal" :treeData="detailModalData" @hide="showDetailsModal= false"></TreeModal>
      </div>
    </div>
    <ChannelOnboardFormModal :show="showPfacModal" :data="pfacModalData" @switchAdded="switchAdded" @hide="showPfacModal = false" />
    <UpdateChannelOnboardPFACModal :show="showUpdate" :row="row" :data="pfacModalData" @switchAdded="switchAdded" @hide="showUpdate = false"  />
    <ConfirmationModal :show="showConfirmationModal" @confirm="confirmResetKeys" message="Are you sure to reset the keys?"
                       title="Reset Keys"
                       @hide="showConfirmationModal = false"></ConfirmationModal>
  </div>
</template>

<script>
import TreeModal from "@/pages/dashboard/merchant/logs/Tree.vue";
import OnboardFormModal from "@/pages/dashboard/merchant/stores/switch/OnboardFormModal.vue";
import ChannelOnboardFormModal from "@/pages/dashboard/merchant/channels/channel-switch/ChannelOnboardFormModal.vue";
import UpdateChannelOnboardPFACModal
  from "@/pages/dashboard/merchant/channels/channel-switch/UpdateChannelOnboardPFACModal.vue";

export default {
  components: {
    UpdateChannelOnboardPFACModal,
    ChannelOnboardFormModal,
    TreeModal,
  },
  created() {
    this.url = "v1/get-merchant-switch-details";
  },
  mounted() {
    localStorage.setItem("url", "v1/get-merchant-switch-details");
    this.checkDataInStore('v1/get-merchant-switch-details')
    if (
      typeof this.$route.params.update == "undefined" &&
      typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }

    this.channelSwitchPFAC = this.$store.getters.getByKey(
        "channelOnboardPFAC"
    );
    this.pfacModalData = {
      channelId: this.channelSwitchPFAC.row.id
    }

  this.channelId = this.channelSwitchPFAC.row.id
    this.getMerchantSwitchDetails()
  },
  data() {
    return {
      channelSwitchPFAC: null,
      channelId: null,
      showPfacModal: false,
      showDetailsModal: false,
      loader: true,
      row: {},
      showUpdate: false,
      pfacModalData: {},
      detailModalData: {},
      switchList: [],
      selectedRow:null,
      showConfirmationModal: false
    };
  },
  methods: {
    resetKeys(item){
      this.selectedRow = item
      this.showConfirmationModal = true
    },
    confirmResetKeys(){
      this.$store.dispatch('exportExcelLoader', true)
      this.makeRequest("post", "v1/reset-switch-device-key", {
        switchConfigId: this.selectedRow.id,
      }).then(callResponse => {
        this.$store.dispatch('exportExcelLoader', false)
        this.showConfirmationModal = false
      });
    },
    update(item){
      this.row = {
        ...item,
        channelId: this.channelSwitchPFAC.row.id
      }
      this.showUpdate = true
    },
    switchAdded() {
      this.getMerchantSwitchDetails()
      this.showPfacModal = false
      this.showUpdate = false
    },
    showDetails(item) {
      this.detailModalData = item.switch_data
      this.showDetailsModal = true
    },
    onboardPfac() {
      this.showPfacModal = true
    },
    getMerchantSwitchDetails(){
      let requestData = {
        typeId: this.channelId,
        type: 2
      }
      this.loader = true
      this.makeRequest("post", "v1/get-merchant-switch-details", requestData, {}, false).then(
          callResponse => {
            this.loader = false
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                let data = []
                data = callResponse.response.data.data;
                if(data){
                  this.switchList = data
                }

              }
            }
          }
      );
    },
  }
};
</script>

